import script from "./loaris-trojan-remover.vue?vue&type=script&setup=true&lang=ts"
export * from "./loaris-trojan-remover.vue?vue&type=script&setup=true&lang=ts"

import "./loaris-trojan-remover.vue?vue&type=style&index=0&id=40d9e484&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d9e484"]])

export default __exports__